import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlayVideo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 8 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.745 3.79982L0.8 7.38482C0.45 7.59482 0 7.34482 0 6.93482V2.93482C0 1.18982 1.885 0.0998235 3.4 0.969824L5.695 2.28982L6.74 2.88982C7.085 3.09482 7.09 3.59482 6.745 3.79982Z",
		fill: "#0E0F0C"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.04442 6.72982L5.01942 7.89982L2.99942 9.06482C2.27442 9.47982 1.45442 9.39482 0.859417 8.97482C0.569417 8.77482 0.604417 8.32982 0.909417 8.14982L7.26442 4.33982C7.56442 4.15982 7.95942 4.32982 8.01442 4.67482C8.13942 5.44982 7.81942 6.28482 7.04442 6.72982Z",
		fill: "#0E0F0C"
	})]
});
export default SvgPlayVideo;
